

const Helpers = {
  assetUrl: (url) => {
    return `http://localhost:8080/${url}`;
  },
  getColorByType: (type) => {
    switch (type) {
      case 'barierka': return '#ff0000';
      case 'listwa_odbojowa': return '#00e34a';
      case 'deska_okalajaca': return '#ffa900';
    }
    return '#000'
  },
  getIconByType: (type) => {
    switch (type) {
      case 'knaga': return require('../assets/img/link-solid.svg').default;
      case 'drabinka': return require('../assets/img/swimming-pool-solid.svg').default;
      case 'strzalka_trapezowa': return require('../assets/img/chevron-up-solid.svg').default;
      case 'strzalka': return require('../assets/img/long-arrow-alt-up-solid.svg').default;
      case 'slupek_pomoc': return require('../assets/img/life-ring-regular.svg').default;
    }
    return require('../assets/img/expand-arrows-alt-solid.svg').default
  }
}

export default Helpers;
